
var SMI_ExtendComponent = (function () {
  "use strict";
  class SMI_ExtendComponent {
    sectionEl = null;
    constructor(sectionID) {
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.checking = "false";
      this.handleWishlist(sectionID);
      this.handleCloseModal();
    }

    handleCloseModal(){
      document.addEventListener('smiLiteModalClose', (e)=>{
        localStorage.setItem('smiIOQV', 1)
        localStorage.setItem('smiIOQA', 1)
        localStorage.setItem("smi-loaded-qv", 1)
        localStorage.setItem("smi-loaded-qa", 1)
        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        let all_pops_false_qv = document.querySelectorAll(".smi-quick-view-1-modal")
        if(all_pops_false_qv && all_pops_false_qv.length){
          all_pops_false_qv.forEach((item, i) =>{
            if(item){
              if(all_pops_false_qv.length > 1){
                if(i>0){
                  item.classList.remove('smi-modal-on-animation')
                }
              }else{
                item.classList.remove('smi-modal-on-animation')
              }
              item.classList.remove('smi-modal-on');
            }
          })
        }

        let all_pops_false_qa = document.querySelectorAll(".smi-quick-add-1-modal")
        if(all_pops_false_qa && all_pops_false_qa.length){
          all_pops_false_qa.forEach((item, i) =>{
            if(item){
              if(all_pops_false_qa.length > 1){
                if(i>0){
                  item.classList.remove('smi-modal-on-animation')
                }
              }else{
                item.classList.remove('smi-modal-on-animation')
              }
              item.classList.remove('smi-modal-on');
            }
          })
        }
        
      let all_popsss = document.querySelectorAll(`.smi-quick-view-content-main`)
        if(all_popsss){
          all_popsss.forEach((item, i) =>{
            if(item){
              item.innerHTML = '<div class="smi-quickview-loader"><div class="loader"></div></div>';  
            }
            
          })    
        }
        let all_popsss_qa = document.querySelectorAll(`.smi-quick-add-content-main`)
        if(all_popsss_qa){
          all_popsss_qa.forEach((item, i) =>{
            if(item){
          item.innerHTML = '<div class="smi-quickadd-loader"><div class="loader"></div></div>';    
            }
          
              
        })
        }
          
      
          if(document.getElementById(`smi-modal-bg`)){
            document.getElementById(`smi-modal-bg`).style=""
          }else{
            // console.log('-----empty modal')
          }
      })
    }

    handleWishlist(secId) {
      let smi_extended_items = localStorage.getItem("smi_extended_items");
      if (!smi_extended_items) {
        let obj = {
          wishlist: [],
          compare: [],
          wishlist_link: "",
          compare_link: "",
          product_id: "",
          product_url: "",
          currentQVP: "",
          currentQAV: ""
        };
        localStorage.setItem("smi_extended_items", JSON.stringify(obj));
      }
      let deletes = document.querySelectorAll(".smi-delete-container");
      if (smi_extended_items) {
        let smi_extended_items_new = localStorage.getItem("smi_extended_items");
        let obj_parse = JSON.parse(smi_extended_items_new);
        try {
          const e_extent_header = document.querySelectorAll(".extend-component-header-total");
          if (e_extent_header) {
            e_extent_header.forEach((item) => {
              if (item.classList.contains(`smi-header-extend-wishlist-total`)) {
                if (obj_parse.wishlist.length > 0) {
                  item.classList.add(`smi-d-flex`);
                  item.innerHTML = obj_parse.wishlist.length;
                } else {
                  item.classList.remove(`smi-d-flex`);
                }
              } else if (item.classList.contains(`smi-header-extend-compare-total`)) {
                if (obj_parse.compare.length > 0) {
                  item.classList.add(`smi-d-flex`);
                  item.innerHTML = obj_parse.compare.length;
                } else {
                  item.classList.remove(`smi-d-flex`);
                }
              }
            });
          }
          const e_extent_account = document.querySelectorAll(".smi-custom-account-extend");
          if (e_extent_account) {
            e_extent_account.forEach((item) => {
              if (item.classList.contains(`smi-custom-account-wishlist`)) {
                if (obj_parse.wishlist.length > 0) {
                  item.innerHTML = `(${obj_parse.wishlist.length})`;
                }
              } else if (item.classList.contains(`smi-custom-account-compare`)) {
                if (obj_parse.compare.length > 0) {
                  item.innerHTML = `(${obj_parse.compare.length})`;
                }
              }
            });
          }
        } catch (error) {}

        deletes.forEach((item, i) => {
          let id = item.getAttribute("product-id");
          let type = item.getAttribute("type-remove");
          try {
            item.addEventListener("click", () => {
              if (type == "wishlist") {
                let wishlistes = document.querySelectorAll(".smi-wishlist-container");
                if (obj_parse.wishlist.includes(id)) {
                  obj_parse.wishlist = obj_parse.wishlist.filter(function (e) {
                    return e !== id;
                  });
                  localStorage.setItem("smi_extended_items", JSON.stringify(obj_parse));
                  try {
                    this.checkSelectItem(wishlistes, id, "remove");
                  } catch (error) {
                    // console.log('err selected item 1: ', error)
                  }
                  document.dispatchEvent(
                  new CustomEvent("smiChangeWishlistCompare", {
                    detail: obj_parse,
                  })
                );
                }
              } else if (type == "compare") {
                let compares = document.querySelectorAll(".smi-compare-container");
                if (obj_parse.compare.includes(id)) {
                  obj_parse.compare = obj_parse.compare.filter(function (e) {return e !== id;});
                  localStorage.setItem("smi_extended_items",JSON.stringify(obj_parse));
                  try {
                    this.checkSelectItem(compares, id, "remove");
                  } catch (error) {
                    // console.log('err selected item 2: ', error)
                  }
                  
                  document.dispatchEvent(
                  new CustomEvent("smiChangeWishlistCompare", {
                    detail: obj_parse,
                  })
                );
                }
              }
            });
          } catch (error) {
            // console.log('err: ', error)
          }
        });
      }
    }
    checkSelectItem(list, mainId, status) {
      list.forEach((item, i) => {
        let id = item.getAttribute("product-id");
        if (id && id == mainId) {
          if (status == "add") {
            item.classList.add("selected-item-extend");
          } else {
            item.classList.remove("selected-item-extend");
          }
        }
      });

      try {
        let smi_extended_items_new = localStorage.getItem("smi_extended_items");
        let obj_parse = JSON.parse(smi_extended_items_new);
        const e_extent_header = document.querySelectorAll(
          ".extend-component-header-total"
        );
        if (e_extent_header) {
          e_extent_header.forEach((item) => {
            if (item.classList.contains(`smi-header-extend-wishlist-total`)) {
              if (obj_parse.wishlist.length > 0) {
                item.classList.add(`smi-d-flex`);
                item.innerHTML = obj_parse.wishlist.length;
              } else {
                item.classList.remove(`smi-d-flex`);
              }
            } else if (
              item.classList.contains(`smi-header-extend-compare-total`)
            ) {
              if (obj_parse.compare.length > 0) {
                item.classList.add(`smi-d-flex`);
                item.innerHTML = obj_parse.compare.length;
              } else {
                item.classList.remove(`smi-d-flex`);
              }
            }
          });
        }
      } catch (error) {}
    }
  }
  return SMI_ExtendComponent;
})();

var SMI_ExtendComponentWishlist = (function () {
  "use strict";
  class SMI_ExtendComponentWishlist {
    sectionEl = null;

    constructor(sectionID) {
      this.handleWishlist(sectionID);
    }

    handleWishlist(secId) {

      let all_smi_quickview_items = document.querySelectorAll(
          `.smi-quickview-extend-items`
        );
        if (all_smi_quickview_items) {
          all_smi_quickview_items.forEach((objExtend) => {
            if (objExtend) {
              const resizeObserver = new ResizeObserver((entries) => {
                if (objExtend.offsetWidth == 0) {
                  objExtend.classList.remove("extend-component-margin");
                  objExtend.classList.remove("extend-component-both");
                } else {
                  if (
                    document.querySelector(`.smi-compare-container-qv`) &&
                    document.querySelector(`.smi-wishlist-container-qv`)
                  ) {
                    if (
                      document.querySelector(`.smi-compare-container-qv`).offsetWidth != 0 && document.querySelector(`.smi-wishlist-container-qv`).offsetWidth != 0
                    ) {
                      objExtend.classList.remove("extend-component-margin");
                      objExtend.classList.add("extend-component-margin-both");
                    } else if (
                      document.querySelector(`.smi-compare-container-qv`).offsetWidth != 0 || document.querySelector(`.smi-wishlist-container-qv`).offsetWidth != 0
                    ) {
                      objExtend.classList.remove(
                        "extend-component-margin-both"
                      );
                      objExtend.classList.add("extend-component-margin");
                    }
                  }
                }
              });
              resizeObserver.observe(objExtend);
            }
          });
        }
      
      let smi_extended_items = localStorage.getItem("smi_extended_items");
      if (!smi_extended_items) {
        let obj = {
          wishlist: [],
          compare: [],
          wishlist_link: "",
          compare_link: "",
          product_id: "",
          product_url: "",
          currentQVP: "",
          currentQAV: ""
        };
        localStorage.setItem("smi_extended_items", JSON.stringify(obj));
      }

      let wishlist_link = "";
      let wishlist_nd_click = "remove";

      try {
        let all_wishlist_link = document.querySelectorAll(
          `.smi-wishlist-page-link`
        );
        let all_wishlist_second_click = document.querySelectorAll(
          `.smi-second-action-wishlist`
        );
        if (all_wishlist_second_click) {
          let last_wishlist_second_click =
            all_wishlist_second_click[all_wishlist_second_click.length - 1];
          
          if (last_wishlist_second_click) {
            wishlist_nd_click = last_wishlist_second_click.value;
          }
        }
        if (all_wishlist_link) {
          let last_wishlist_link =
            all_wishlist_link[all_wishlist_link.length - 1];
          let all_wishlist_link_in_account = document.querySelectorAll(
            `.smi-classic-account-wishlist-url`
          );
          let all_wishlist_link_tag = document.querySelectorAll(
            `.smi-header-extend-wishlist-total-link`
          );
          if (last_wishlist_link && last_wishlist_link.value != "") {
            
            wishlist_link = last_wishlist_link.value;
            if (smi_extended_items) {
              let smi_extended_items_new =
                localStorage.getItem("smi_extended_items");
              let obj_parse = JSON.parse(smi_extended_items_new);
              obj_parse.wishlist_link = wishlist_link;
              localStorage.setItem(
                "smi_extended_items",
                JSON.stringify(obj_parse)
              );
            }
            if (all_wishlist_link_tag) {
              all_wishlist_link_tag.forEach((item2) => {
                item2.setAttribute("href", last_wishlist_link.value);
              });
            }

            if(document.querySelectorAll(".smi-classic-account-wishlist-dp")){
              document.querySelectorAll(".smi-classic-account-wishlist-dp").forEach(item =>{
                item.classList.remove('smi-classic-account-wishlist-dp-none')
              })
            }
            if (all_wishlist_link_in_account) {
              all_wishlist_link_in_account.forEach((item2) => {
                item2.setAttribute("href", last_wishlist_link.value);
                // item2.style.display = 'block'
                item2.classList.remove("hide-element-extend");
              });
            }
          } else {
            if(document.querySelectorAll(".smi-classic-account-wishlist-dp")){
              document.querySelectorAll(".smi-classic-account-wishlist-dp").forEach(item =>{
                item.classList.add('smi-classic-account-wishlist-dp-none')
              })
            }
            if (smi_extended_items) {
              let smi_extended_items_new =
                localStorage.getItem("smi_extended_items");
              let obj_parse = JSON.parse(smi_extended_items_new);
              obj_parse.wishlist_link = "";
              localStorage.setItem(
                "smi_extended_items",
                JSON.stringify(obj_parse)
              );
            }
            if (all_wishlist_link_in_account) {
              all_wishlist_link_in_account.forEach((item2) => {
                item2.classList.add("hide-element-extend");
                // item2.style.display = 'none'
              });
            }

            if (all_wishlist_link_tag) {
              all_wishlist_link_tag.forEach((item2) => {
                item2.setAttribute("href", "pages/wishlist");
              });
            }
          }
        }

        let wishlistes = document.querySelectorAll(".smi-wishlist-container");
        
        wishlistes.forEach((item, i) => {
          let id = item.getAttribute("product-id");
          let smi_extended_items_new =
            localStorage.getItem("smi_extended_items");
          let obj_parse = JSON.parse(smi_extended_items_new);
          if (id && obj_parse.wishlist.includes(id)) {
            item.classList.add("selected-item-extend");
          }

          item.addEventListener("click", (e) => {
            
            if(localStorage.getItem('smi-wl-o-data') == null || localStorage.getItem('smi-wl-o-data') != 9999){
              localStorage.setItem('smi-wl-o-data', 9999)
              
              smi_extended_items_new = localStorage.getItem("smi_extended_items");
              obj_parse = JSON.parse(smi_extended_items_new);
              
              if (obj_parse.wishlist.includes(id)) {
                
                if (wishlist_nd_click == "remove") {
                  e.preventDefault()
                  item.classList.remove("selected-item-extend");
                  obj_parse.wishlist = obj_parse.wishlist.filter(function (e) {
                    return e !== id;
                  });
                  localStorage.setItem(
                    "smi_extended_items",
                    JSON.stringify(obj_parse)
                  );
  
                  try {
                    this.checkSelectItem(wishlistes, id, "remove");
                  } catch (error) {
                  }
                  
                
                  // item.removeAttribute("href");
                  document.dispatchEvent(
                    new CustomEvent("smiChangeWishlistCompare", {
                      detail: obj_parse,
                    })
                  );
                  
                } else if (wishlist_nd_click != "remove") {
                  e.preventDefault()
                  if (wishlist_link && wishlist_link != "") {
                    window.location.href = wishlist_link;
                    //item.setAttribute("href", wishlist_link);
                  } else {
                    // item.setAttribute("href", "pages/wishlist");
                    window.location.href = "pages/wishlist";
                  }
                }
              } else {
                e.preventDefault()
                obj_parse.wishlist.push(id);
                localStorage.setItem(
                  "smi_extended_items",
                  JSON.stringify(obj_parse)
                );
                item.classList.add("selected-item-extend");
                try {
                  this.checkSelectItem(wishlistes, id, "add");
                } catch (error) {
                  // console.log('err selected item 4: ', error)
                }
                document.dispatchEvent(
                    new CustomEvent("smiChangeWishlistCompare", {
                      detail: obj_parse,
                    })
                  );
              }
              setTimeout(()=>{
                localStorage.setItem('smi-wl-o-data', 1)
              }, 200)
            }
            
            
          });
        });
      } catch (err) {
        // console.log("err wishlist extend: ", err);
      }
    }

    checkSelectItem(list, mainId, status) {
      list.forEach((item, i) => {
        let id = item.getAttribute("product-id");
        if (id && id == mainId) {
          if (status == "add") {
            item.classList.add("selected-item-extend");
          } else {
            item.classList.remove("selected-item-extend");
          }
        }
      });

      try {
        let smi_extended_items_new = localStorage.getItem("smi_extended_items");
        let obj_parse = JSON.parse(smi_extended_items_new);
        const e_extent_header = document.querySelectorAll(
          ".extend-component-header-total"
        );
        
        if (e_extent_header) {
          e_extent_header.forEach((item) => {
            if (item.classList.contains(`smi-header-extend-wishlist-total`)) {
              if (obj_parse.wishlist.length > 0) {
                item.classList.add(`smi-d-flex`);
                item.innerHTML = obj_parse.wishlist.length;
              } else {
                item.classList.remove(`smi-d-flex`);
              }
            } else if (
              item.classList.contains(`smi-header-extend-compare-total`)
            ) {
              if (obj_parse.compare.length > 0) {
                item.classList.add(`smi-d-flex`);
                item.innerHTML = obj_parse.compare.length;
              } else {
                item.classList.remove(`smi-d-flex`);
              }
            }
          });
        }
      } catch (error) {}
    }
  }

  return SMI_ExtendComponentWishlist;
})();

var SMI_ExtendComponentCompare = (function () {
  "use strict";
  class SMI_ExtendComponentCompare {
    sectionEl = null;

    constructor(sectionID) {
      this.handleCompare(sectionID);
    }

    handleCompare(secId) {

      let all_smi_quickview_items = document.querySelectorAll(
          `.smi-quickview-extend-items`
        );
        if (all_smi_quickview_items) {
          all_smi_quickview_items.forEach((objExtend) => {
            if (objExtend) {
              const resizeObserver = new ResizeObserver((entries) => {
                if (objExtend.offsetWidth == 0) {
                  objExtend.classList.remove("extend-component-margin");
                  objExtend.classList.remove("extend-component-both");
                } else {
                  if (
                    document.querySelector(`.smi-compare-container-qv`) &&
                    document.querySelector(`.smi-wishlist-container-qv`)
                  ) {
                    if (
                      document.querySelector(`.smi-compare-container-qv`).offsetWidth != 0 && document.querySelector(`.smi-wishlist-container-qv`).offsetWidth != 0
                    ) {
                      
                      objExtend.classList.remove("extend-component-margin");
                      objExtend.classList.add("extend-component-margin-both");
                    } else if (
                      document.querySelector(`.smi-compare-container-qv`).offsetWidth != 0 || document.querySelector(`.smi-wishlist-container-qv`).offsetWidth != 0
                    ) {
                      
                      objExtend.classList.remove(
                        "extend-component-margin-both"
                      );
                      objExtend.classList.add("extend-component-margin");
                    }
                  }
                }
              });
              resizeObserver.observe(objExtend);
            }
          });
        }
      
      let smi_extended_items = localStorage.getItem("smi_extended_items");
      if (!smi_extended_items) {
        let obj = {
          wishlist: [],
          compare: [],
          wishlist_link: "",
          compare_link: "",
          product_id: "",
          product_url: "",
          currentQVP: "",
          currentQAV: ""
        };
        localStorage.setItem("smi_extended_items", JSON.stringify(obj));
      }

      let compare_link = "";
      let compare_nd_click = "remove";

      try {
        let all_compare_link = document.querySelectorAll(
          `.smi-compare-page-link`
        );
        let all_compare_second_click = document.querySelectorAll(
          `.smi-second-action-compare`
        );

        if (all_compare_second_click) {
          let last_compare_second_click =
            all_compare_second_click[all_compare_second_click.length - 1];
          if (last_compare_second_click) {
            compare_nd_click = last_compare_second_click.value;
          }
        }

        if (all_compare_link) {
          let last_compare_link = all_compare_link[all_compare_link.length - 1];
          let all_compare_link_in_account = document.querySelectorAll(
            `.smi-classic-account-compare-url`
          );
          let all_compare_link_tag = document.querySelectorAll(
            `.smi-header-extend-compare-total-link`
          );
          if (last_compare_link && last_compare_link.value != "") {
            compare_link = last_compare_link.value;

            if (smi_extended_items) {
              let smi_extended_items_new =
                localStorage.getItem("smi_extended_items");
              let obj_parse = JSON.parse(smi_extended_items_new);
              obj_parse.compare_link = compare_link;
              localStorage.setItem(
                "smi_extended_items",
                JSON.stringify(obj_parse)
              );
            }

            if (all_compare_link_tag) {
              all_compare_link_tag.forEach((item2) => {
                item2.setAttribute("href", last_compare_link.value);
              });
            }

            if(document.querySelectorAll(".smi-classic-account-compare-dp")){
              document.querySelectorAll(".smi-classic-account-compare-dp").forEach(item =>{
                item.classList.remove('smi-classic-account-compare-dp-none')
              })
            }

            if (all_compare_link_in_account) {
              all_compare_link_in_account.forEach((item2) => {
                item2.setAttribute("href", last_compare_link.value);
                // item2.style.display = 'block'
                item2.classList.remove("hide-element-extend");
              });
            }
          } else {
            if (smi_extended_items) {
              let smi_extended_items_new =
                localStorage.getItem("smi_extended_items");
              let obj_parse = JSON.parse(smi_extended_items_new);
              obj_parse.compare_link = "";
              localStorage.setItem(
                "smi_extended_items",
                JSON.stringify(obj_parse)
              );
            }
            if(document.querySelectorAll(".smi-classic-account-compare-dp")){
              document.querySelectorAll(".smi-classic-account-compare-dp").forEach(item =>{
                item.classList.add('smi-classic-account-compare-dp-none')
              })
            }
            if (all_compare_link_in_account) {
              all_compare_link_in_account.forEach((item2) => {
                // item2.style.display = 'none'
                item2.classList.add("hide-element-extend");
              });
            }
            if (all_compare_link_tag) {
              all_compare_link_tag.forEach((item2) => {
                item2.setAttribute("href", "pages/compare");
              });
            }
          }
        }

        let compares = document.querySelectorAll(".smi-compare-container");

        compares.forEach((item, i) => {
          let smi_extended_items_new =
            localStorage.getItem("smi_extended_items");
          let obj_parse = JSON.parse(smi_extended_items_new);
          let id = item.getAttribute("product-id");
          if (id && obj_parse.compare.includes(id)) {
            item.classList.add("selected-item-extend");
          }
          item.addEventListener("click", (e) => {
            
            if(localStorage.getItem('smi-cp-o-data') == null || localStorage.getItem('smi-cp-o-data') != 9999){
              localStorage.setItem('smi-cp-o-data', 9999)
              
              smi_extended_items_new = localStorage.getItem("smi_extended_items");
              obj_parse = JSON.parse(smi_extended_items_new);
              
              if (obj_parse.compare.includes(id)) {
                if (compare_nd_click == "remove") {
                  e.preventDefault()
                  item.classList.remove("selected-item-extend");
                  obj_parse.compare = obj_parse.compare.filter(function (e) {
                    return e !== id;
                  });
                  localStorage.setItem(
                    "smi_extended_items",
                    JSON.stringify(obj_parse)
                  );
                  try {
                    this.checkSelectItem(compares, id, "remove");
                  } catch (error) {
                    // console.log('err selected item 5: ', error)
                  }
                  
                  // item.removeAttribute("href");
                  document.dispatchEvent(
                    new CustomEvent("smiChangeWishlistCompare", {
                      detail: obj_parse,
                    })
                  );
                  
                } else if (compare_nd_click != "remove") {
                  e.preventDefault()
                  if (compare_link && compare_link != "") {
                    // item.setAttribute("href", compare_link);
                    window.location.href = compare_link;
                  } else {
                    // item.setAttribute("href", "pages/compare");
                    window.location.href = "pages/compare";
                  }
                }
              } else {
                e.preventDefault()
                obj_parse.compare.push(id);
                localStorage.setItem(
                  "smi_extended_items",
                  JSON.stringify(obj_parse)
                );
                item.classList.add("selected-item-extend");
                try {
                  this.checkSelectItem(compares, id, "add");
                } catch (error) {
                  // console.log('err selected item 6: ', error)
                }
                
                document.dispatchEvent(
                  new CustomEvent("smiChangeWishlistCompare", {
                    detail: obj_parse,
                  })
                );
              }

              setTimeout(()=>{
                localStorage.setItem('smi-cp-o-data', 1)
              }, 200)
            }
            
            
          });
        });
      } catch (error) {
        // console.log("err compare extend: ", error);
      }
    }

    checkSelectItem(list, mainId, status) {
      list.forEach((item, i) => {
        let id = item.getAttribute("product-id");
        if (id && id == mainId) {
          if (status == "add") {
            item.classList.add("selected-item-extend");
          } else {
            item.classList.remove("selected-item-extend");
          }
        }
      });

      try {
        let smi_extended_items_new = localStorage.getItem("smi_extended_items");
        let obj_parse = JSON.parse(smi_extended_items_new);
        const e_extent_header = document.querySelectorAll(
          ".extend-component-header-total"
        );
        if (e_extent_header) {
          e_extent_header.forEach((item) => {
            if (item.classList.contains(`smi-header-extend-wishlist-total`)) {
              if (obj_parse.wishlist.length > 0) {
                item.classList.add(`smi-d-flex`);
                item.innerHTML = obj_parse.wishlist.length;
              } else {
                item.classList.remove(`smi-d-flex`);
              }
            } else if (
              item.classList.contains(`smi-header-extend-compare-total`)
            ) {
              if (obj_parse.compare.length > 0) {
                item.classList.add(`smi-d-flex`);
                item.innerHTML = obj_parse.compare.length;
              } else {
                item.classList.remove(`smi-d-flex`);
              }
            }
          });
        }
      } catch (error) {}
    }
  }

  return SMI_ExtendComponentCompare;
})();

var SMI_ExtendComponentQuickview = (function () {
  "use strict";
  class SMI_ExtendComponentQuickview {
    sectionEl = null;

    constructor(sectionID) {
      setTimeout(()=>{
        this.handleQuickview(sectionID);
      }, 50)
      this.controller = new AbortController();
      this.dataQV = []
    }

    handleQuickview() {
    }
  }
  return SMI_ExtendComponentQuickview;
})();


var SMI_ExtendComponentQuickAdd = (function () {
  "use strict";
  class SMI_ExtendComponentQuickAdd {
    sectionEl = null;

    constructor(sectionID) {
      this.controller = new AbortController();
      this.dataQA = []
      setTimeout(()=>{
        this.handleQuickAdd(sectionID);
      }, 0)
    }

    handleQuickAdd() {
      let quick_adds = document.querySelectorAll(".smi-quickadd-container");
      quick_adds.forEach((item, i) => {
        try {
          } catch (error) {
            // console.log('err click modal: ', err)
          }
      })
    }

  }

  return SMI_ExtendComponentQuickAdd;
})();